// Anthology: swap the main product image to reflect the selected Letter
// (and Color) on the Custom Mini Letter Necklace - and ONLY that
// combination (Base Metal changes are untouched, since the charm photos
// don't differ by Base Metal, only by Color + Letter). Modeled on
// anthology-birthstone-image.js: the per-letter charm photos are real
// product media (so Shopify can host and serve them), but
// media-gallery.liquid skips them when rendering the thumbnail rail (a
// fixed list of media IDs), so they never show up as their own thumbnail.
//
// Because these images aren't real thumbnails, the swap doesn't go through
// theme.js's click handler at all - it just shows/hides the right
// .product-media element directly, keyed off each variant's assigned
// image ID (read from ProductJson, so no alt-text convention is needed).
//
// The Color and Letter <select>s are found by OPTION POSITION (2nd and
// 3rd option on the product), not by an id like #option-color-finish -
// that id is auto-generated from the option's name (option-{{ name |
// handle }}), so a merchant renaming "Color & Finish" to just "Color" in
// Shopify admin silently broke an earlier, name-based version of this
// script. Position (Base Metal, Color, Letter) is far less likely to
// change than the option's exact label text.
//
// theme.js's own ProductMediaGallery has a recurring bug (unrelated to
// this script, also present on the birthstone necklace): something in its
// periodic reflow/zoom code repeatedly re-shows the gallery's first photo
// without hiding whatever else is currently shown, so a second, wrong
// image can re-appear stacked underneath ours at any point, not just on
// first load. Rather than patch that shared, 137KB core file, this script
// re-asserts the correct photo on every watchdog tick (see setInterval
// below) so any stray re-show self-heals within ~1.5s. That re-assertion
// only happens while "following" the Color/Letter selection - a manual
// thumbnail click switches off following (so periodic re-assertion can't
// fight the user's own choice) until the next Color/Letter change turns
// it back on.
(function ($) {
  function getProductData($el) {
    var productId = $el.closest('.product-container').find('form.product-form').data('product-id');
    if (!productId) return null;
    var scriptEl = document.getElementById('ProductJson-' + productId);
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  // 1-based position among product.options_with_values, matching each
  // option's rendered order in .option-selectors (Base Metal=1, Color=2,
  // Letter=3) - independent of what the option happens to be named.
  function optionSelectByPosition($container, position) {
    return $container.find('.option-selectors > .selector-wrapper.option select').eq(position - 1);
  }

  function findLetterVariant(data, color, letter) {
    if (!data || !data.variants || !color || !letter) return null;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (v.option2 === color && v.option3 === letter) return v;
    }
    return null;
  }

  function showOnlyMedia($gallery, mediaId) {
    var $all = $gallery.find('.main .product-media');
    $all.not('[data-media-id="' + mediaId + '"]').each(function () {
      // don't interrupt a playing video/3D model - only images are involved
      // in the letter swap, so leave other media types to theme.js
      if ($(this).data('media-type') === 'image') $(this).hide();
    });
    $all.filter('[data-media-id="' + mediaId + '"]').show();
  }

  function letterMediaId($gallery, color, letter) {
    var data = getProductData($gallery);
    var variant = findLetterVariant(data, color, letter);
    return variant && variant.featured_media && variant.featured_media.id;
  }

  function applyLetterImage($gallery, color, letter) {
    var mediaId = letterMediaId($gallery, color, letter);
    // No dedicated charm photo for this exact Color+Letter combo (e.g. the
    // default 14K Yellow Gold "A" reuses a general hero shot) - leave
    // whatever image is already showing rather than forcing a blank state.
    if (!mediaId) return;
    showOnlyMedia($gallery, mediaId);
  }

  function bindLetterWatch($gallery) {
    var $container = $gallery.closest('.product-container');
    var $colorSelect = optionSelectByPosition($container, 2);
    var $letterSelect = optionSelectByPosition($container, 3);
    if (!$colorSelect.length || !$letterSelect.length) return;

    reassertLetterImage($gallery); // follow mode: re-apply every watchdog tick

    if ($gallery.data('anthologyLetterBound')) return;
    $gallery.data('anthologyLetterBound', true);
    $gallery.data('anthologyLetterFollow', true);

    function apply() {
      $gallery.data('anthologyLetterFollow', true);
      applyLetterImage($gallery, $colorSelect.val(), $letterSelect.val());
    }

    $colorSelect.on('change.anthologyLetter', apply);
    $letterSelect.on('change.anthologyLetter', apply);

    // A real thumbnail click always wins over a letter swap - re-assert
    // single visibility immediately, and stop the watchdog from re-showing
    // the letter photo over it until Color/Letter changes again.
    $gallery.on('click.anthologyLetter', '.thumbnails .thumbnail', function () {
      $gallery.data('anthologyLetterFollow', false);
      showOnlyMedia($gallery, $(this).data('media-id'));
    });

    apply(); // match the pre-selected values on load
  }

  function reassertLetterImage($gallery) {
    if (!$gallery.data('anthologyLetterBound') || $gallery.data('anthologyLetterFollow') === false) return;
    var $container = $gallery.closest('.product-container');
    applyLetterImage($gallery, optionSelectByPosition($container, 2).val(), optionSelectByPosition($container, 3).val());
  }

  function initAll() {
    $('.product-gallery').each(function () {
      bindLetterWatch($(this));
    });
  }

  // theme.js's own ProductMediaGallery init (which unconditionally shows
  // whichever media is first, with no awareness of this script) runs from
  // theme.Sections.register(), fired synchronously the moment theme.js's
  // <script> tag executes - which happens to be AFTER this deferred script
  // tag in the page. Calling initAll() synchronously here would apply our
  // swap first, only for theme.js's init to clobber it moments later,
  // leaving two photos visible at once. Deferring the first run by one
  // tick (setTimeout) lets theme.js's own init finish first, so our swap
  // is what's on screen last.
  function deferredInitAll() {
    setTimeout(initAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInitAll);
  } else {
    deferredInitAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  setInterval(initAll, 1500);
})(jQuery);
